import "./main.scss";
import "../shared/main.scss";
import configureClient from "../shared/client";

configureClient(window.__initialState);



// WEBPACK FOOTER //
// ./assets/pois/index.js